var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpicyBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "250 250 600 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "a694be84-080e-4f6f-9374-311b26aa9fae"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "a796f505-49a1-4da4-8fbc-3eec3f79ab81"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -4.27 4.27 0 461.55 404.92)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.26 8.52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-34.36, -40.46)",
    d: "M 57.3 26.8 L 55.599999999999994 28.2 C 55.199999999999996 28.599999999999998 55.099999999999994 29.2 55.49999999999999 29.599999999999998 C 55.49999999999999 29.599999999999998 55.49999999999999 29.7 55.599999999999994 29.7 C 55.99999999999999 30.099999999999998 56.49999999999999 30.099999999999998 56.89999999999999 29.8 L 58.599999999999994 28.400000000000002 C 58.99999999999999 28.000000000000004 59.099999999999994 27.400000000000002 58.699999999999996 27.000000000000004 C 58.4 26.5 57.7 26.5 57.3 26.8 z M 52.7 30.6 L 33.7 46.2 C 33.300000000000004 46.6 32.6 46.5 32.2 46.1 L 29.900000000000002 43.800000000000004 C 29.500000000000004 43.400000000000006 28.900000000000002 43.400000000000006 28.500000000000004 43.800000000000004 C 28.100000000000005 44.2 28.100000000000005 44.800000000000004 28.500000000000004 45.2 L 30.100000000000005 46.800000000000004 L 28.700000000000006 48.2 L 15.9 35.4 L 17.3 34 L 25.8 42.5 C 26.2 42.9 26.8 42.9 27.2 42.5 C 27.599999999999998 42.1 27.599999999999998 41.5 27.2 41.1 L 17.9 31.8 C 17.5 31.400000000000002 17.5 30.8 17.799999999999997 30.400000000000002 C 18.099999999999998 30.000000000000004 18.099999999999998 29.400000000000002 17.699999999999996 29.000000000000004 C 17.299999999999997 28.600000000000005 16.599999999999994 28.700000000000003 16.299999999999997 29.100000000000005 C 15.499999999999996 30.100000000000005 15.399999999999997 31.400000000000006 15.999999999999996 32.50000000000001 L 14.5 34 L 13.8 33.3 C 13.4 32.9 12.8 32.9 12.4 33.3 C 8.9 36.8 8.9 42.5 12.4 46 L 18.1 51.7 C 21.6 55.2 27.3 55.2 30.8 51.7 C 31.2 51.300000000000004 31.2 50.7 30.8 50.300000000000004 L 30 49.5 L 31.5 48 C 32.6 48.6 34 48.5 34.9 47.6 L 53.9 32 C 54.3 31.7 54.4 31 54 30.6 C 53.8 30.3 53.2 30.2 52.7 30.6 z M 19.4 50.2 L 13.7 44.5 C 11.2 42 11 38.1 13 35.4 L 28.5 50.9 C 25.8 52.9 21.9 52.7 19.4 50.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 8.78 -10.45)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-40.88, -21.49)",
    d: "M 61.7 18.9 C 61.7 18.9 61.7 18.9 61.7 18.9 L 45.1 2.3 C 44.1 1.2999999999999998 42.800000000000004 0.7999999999999998 41.4 0.8999999999999999 C 40 0.9999999999999999 38.699999999999996 1.5999999999999999 37.9 2.7 L 18.8 26.1 C 18.2 26.900000000000002 18.900000000000002 27.5 18.900000000000002 27.5 C 19.3 27.9 20.000000000000004 27.8 20.3 27.4 L 39.4 3.9 C 39.9 3.3 40.699999999999996 2.9 41.5 2.8 C 42.3 2.8 43.1 3.0999999999999996 43.7 3.5999999999999996 L 45.7 5.6 L 22.2 31.9 C 21.599999999999998 32.6 22.3 33.3 22.3 33.3 C 22.7 33.699999999999996 23.3 33.599999999999994 23.7 33.199999999999996 L 47.1 7.1 L 51.300000000000004 11.3 L 42 20.6 C 41.6 21 41.6 21.6 42 22 C 42.4 22.4 43 22.4 43.4 22 L 52.7 12.7 L 56.900000000000006 16.9 L 30.8 40.3 C 30.1 41 30.7 41.699999999999996 30.8 41.8 C 31.2 42.199999999999996 31.8 42.199999999999996 32.2 41.8 L 58.400000000000006 18.299999999999997 L 60.400000000000006 20.299999999999997 C 60.400000000000006 20.299999999999997 60.400000000000006 20.299999999999997 60.400000000000006 20.299999999999997 C 61.00000000000001 20.9 61.300000000000004 21.599999999999998 61.2 22.499999999999996 C 61.2 23.299999999999997 60.800000000000004 24.099999999999998 60.1 24.599999999999998 C 59.7 24.999999999999996 59.6 25.599999999999998 60 25.999999999999996 C 60.4 26.399999999999995 61 26.499999999999996 61.4 26.099999999999998 C 62.5 25.2 63.1 23.9 63.199999999999996 22.499999999999996 C 63.2 21.2 62.7 19.8 61.7 18.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.5 -1.54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-33.6, -30.4)",
    d: "M 27.9 37.5 L 40.7 24.7 C 41.1 24.3 41.1 23.7 40.7 23.3 C 40.300000000000004 22.900000000000002 39.7 22.900000000000002 39.300000000000004 23.3 L 26.5 36.1 C 26.1 36.5 26.1 37.1 26.5 37.5 C 26.9 37.9 27.5 37.9 27.9 37.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.6 13.36)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -16.2 10.56)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -10.6 16.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -24.2 16.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -28.1 20.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -30.1 28.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -26.1 24.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -20.1 20.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -16.2 24.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -22.1 26.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -24.1 30.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.1 30.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.18 0 0 7.18 540 665.33)",
    id: "e8be39e2-560b-467e-b4cb-52bf9e54a78f"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fillRule: "nonzero",
      opacity: 1
    },
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-34.59, -34.59)",
    d: "M 56.48 29.333 C 56.050999999999995 29.333 55.626999999999995 29.355999999999998 55.208999999999996 29.397 L 51.892999999999994 15.586999999999998 C 51.730999999999995 14.912999999999998 51.126999999999995 14.437999999999999 50.43399999999999 14.437999999999999 L 45.27299999999999 14.437999999999999 C 44.444999999999986 14.437999999999999 43.77299999999999 15.11 43.77299999999999 15.937999999999999 C 43.77299999999999 16.766 44.444999999999986 17.438 45.27299999999999 17.438 L 49.25199999999999 17.438 L 50.37399999999999 22.112 L 28.005 22.112 L 26.874 18.043999999999997 L 31.04 18.043999999999997 C 31.868 18.043999999999997 32.54 17.371999999999996 32.54 16.543999999999997 C 32.54 15.715999999999998 31.868 15.043999999999997 31.04 15.043999999999997 L 24.9 15.043999999999997 C 24.430999999999997 15.043999999999997 23.99 15.262999999999996 23.706 15.636999999999997 C 23.423 16.009999999999998 23.33 16.493999999999996 23.455 16.945999999999998 L 25.264999999999997 23.458 L 19.197999999999997 31.137 C 17.294999999999998 30 15.079999999999997 29.334 12.707999999999997 29.334 C 5.7 29.333 0 35.035 0 42.042 C 0 49.04900000000001 5.7 54.749 12.707 54.749 C 19.299 54.749 24.733 49.702000000000005 25.353 43.27 L 31.911 43.27 C 31.912000000000003 43.27 31.913 43.27 31.914 43.27 C 32.046 43.27 32.18 43.253 32.313 43.216 C 32.35 43.206 32.383 43.188 32.418 43.175000000000004 C 32.444 43.166000000000004 32.467999999999996 43.156000000000006 32.494 43.146 C 32.648 43.081 32.786 42.994 32.905 42.888 C 32.913000000000004 42.881 32.924 42.878 32.932 42.870999999999995 L 51.273 25.856999999999996 L 52.283 30.062999999999995 C 47.336 31.802999999999994 43.774 36.50899999999999 43.774 42.04299999999999 C 43.774 49.04999999999999 49.474000000000004 54.74999999999999 56.481 54.74999999999999 C 63.488 54.74999999999999 69.188 49.04999999999999 69.188 42.04299999999999 C 69.188 35.035999999999994 63.487 29.333 56.48 29.333 z M 26.26 27.037 L 29.938000000000002 40.269 L 25.277 40.269 C 24.877000000000002 37.424 23.542 34.878 21.579 32.96 L 26.26 27.037 z M 19.706 35.331 C 20.99 36.67 21.894 38.372 22.246 40.269000000000005 L 15.805 40.269000000000005 L 19.706 35.331 z M 12.707 51.749 C 7.354 51.749 3 47.394 3 42.042 C 3 36.690000000000005 7.354 32.334 12.707 32.334 C 14.378 32.334 15.951 32.759 17.326 33.505 L 11.530000000000001 40.84 C 11.174000000000001 41.291000000000004 11.106000000000002 41.906000000000006 11.357000000000001 42.42400000000001 C 11.607000000000001 42.94100000000001 12.131 43.27 12.707 43.27 L 22.329 43.27 C 21.722 48.043 17.643 51.749 12.707 51.749 z M 32.697 38.994 L 28.839000000000002 25.113 L 47.662000000000006 25.113 L 32.697 38.994 z M 56.48 51.749 C 51.126999999999995 51.749 46.772999999999996 47.395 46.772999999999996 42.042 C 46.772999999999996 37.922000000000004 49.357 34.402 52.986 32.995000000000005 L 55.021 41.47200000000001 C 55.187 42.16000000000001 55.801 42.62100000000001 56.479 42.62100000000001 C 56.594 42.62100000000001 56.711999999999996 42.607000000000006 56.830999999999996 42.58000000000001 C 57.635999999999996 42.387000000000015 58.132999999999996 41.576000000000015 57.93899999999999 40.77000000000001 L 55.919999999999995 32.36200000000001 C 56.105999999999995 32.351000000000006 56.291 32.33400000000001 56.48 32.33400000000001 C 61.833 32.33400000000001 66.187 36.68900000000001 66.187 42.04200000000001 C 66.187 47.39500000000001 61.833 51.749 56.48 51.749 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpicyBike);
export default __webpack_public_path__ + "static/media/spicy_bike.f1a50a055d1630accf13a5c316ebc0b0.svg";
export { ForwardRef as ReactComponent };